import { connect } from 'react-redux';
import { setParamValueAction } from '../../../reducers/reports.reducers';
import ParamFilter from './param-filter';


const mapStateToProps = () => ({
});

const mapDispatchToProps = dispatch => ({
  setParamValue: paramValue => dispatch(setParamValueAction(paramValue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParamFilter);
